"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SettingsProvider = exports.SettingsContext = void 0;
var tslib_1 = require("tslib");
var react_1 = (0, tslib_1.__importStar)(require("react"));
var assign_1 = (0, tslib_1.__importDefault)(require("lodash/fp/assign"));
var hooks_1 = require("../hooks");
exports.SettingsContext = (0, react_1.createContext)(null);
var SettingsProvider = function (_a) {
    var children = _a.children;
    var _b = (0, hooks_1.useUserSettings)(), data = _b.data, settingsLoading = _b.loading;
    var _c = (0, react_1.useState)(null), settings = _c[0], setSettings = _c[1];
    var _d = (0, react_1.useState)(true), loading = _d[0], setLoading = _d[1];
    var updateUserSettings = (0, hooks_1.useUpdateUserSettings)()[0];
    (0, react_1.useEffect)(function () {
        if (!settingsLoading) {
            setSettings(data);
            setLoading(false);
        }
    }, [setLoading, settingsLoading, data]);
    var setSettingsInContext = (0, react_1.useCallback)(function (newSettings) {
        setSettings((0, tslib_1.__assign)((0, tslib_1.__assign)({}, settings), { DataParams: newSettings }));
        setLoading(false);
    }, [settings]);
    var setNewSettings = (0, react_1.useCallback)(function (newSettings) {
        setLoading(true);
        var mergedParams = (0, assign_1.default)(settings && settings.DataParams, newSettings);
        updateUserSettings(mergedParams, function () {
            setSettingsInContext(mergedParams);
        }, function () { return setLoading(false); });
    }, [settings, setSettingsInContext, updateUserSettings]);
    var values = (0, react_1.useMemo)(function () { return ({
        settings: settings,
        setSettings: setSettings,
        loading: loading,
        setNewSettings: setNewSettings,
    }); }, [settings, setSettings, loading, setNewSettings]);
    return (react_1.default.createElement(exports.SettingsContext.Provider, { value: values }, children));
};
exports.SettingsProvider = SettingsProvider;
